import { Analytics } from "@vercel/analytics/react"
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { Home } from './Home.js';
import { About } from './About.js';
import { Publication } from './Publication.js';
import { AnimationAndInteraction } from './AnimationAndInteraction.js';
import { DocumentaryAndEducation } from './DocumentaryAndEducation.js';
import { ShopDonate } from './ShopDonate.js';
import { AdmittedStudentsDay } from './AdmittedStudentsDay.js';
import { TooComfortably } from './TooComfortably.js';
import { GrimReynolds } from './GrimReynolds.js';
import { BookmarksForBrooklynPark } from './BookmarksForBrooklynPark.js';
import { All52 } from './All52.js';
import { AHole } from './AHole.js';
import { HDYLSWWYD } from './HDYLSWWYD.js';
import { WetCloud } from './WetCloud.js';
import { SuperSonic } from './SuperSonic.js';
import { ShapeOfYou } from './ShapeOfYou.js';
import { MajorMinorFair } from './MajorMinorFair.js';
import { Workshops } from './Workshops.js';
import { OpenMic } from './OpenMic.js';
import { PoetryAndPerformance} from './PoetryAndPerformance.js';
import { Shoelaces} from './Shoelaces.js';
import { MotionReel} from './MotionReel.js';
import { Preach} from './Preach.js';
import { GYMcad} from './GYMcad.js';
import { WeatherBody} from './WeatherBody.js';
import { KidsTable} from './KidsTable.js';
import { NineteenRules} from './NineteenRules.js';
import { FreedomSchool} from './FreedomSchool.js';





function App() {
  const isBackgroundRed = true;
  return (

<BrowserRouter>
<head>

<title>Amar Agba</title>

</head>

<div class="nav-container">

  {/* 
  <div class="videoheadercontainer">
      <video autoplay controls loop>
        <source src="WetCloud(Visual Loop).mp4" type="video/mp4"/>
      </video>  
    </div>/
    */} 

<nav class="navbar">
  <a href="/about">

</a>
&ensp;
    <Link to="/About" className="nav-link">
    AMAR
</Link>

    <Link to="/Publication" className="nav-link">
    DESIGN
</Link>

    <Link to="/AnimationAndInteraction" className="nav-link">
    PROGRAMMING</Link>

    <Link to="/DocumentaryAndEducation" className="nav-link">
    DOCUMENTARY
</Link>  

    <Link to="/PoetryAndPerformance" className="nav-link">
    RYTHM & POETRY
</Link>  



</nav>



<Routes>
    <Route path="/" element={<About/>} />
    <Route path="/Publication" element={<Publication/>} />
    <Route path="/AnimationAndInteraction" element={<AnimationAndInteraction/>} />
    <Route path="/ShopDonate" element={<ShopDonate/>} />
    <Route path="/DocumentaryAndEducation" element={<DocumentaryAndEducation/>} />
    <Route path="/AdmittedStudentsDay" element={<AdmittedStudentsDay/>} />
    <Route path="/TooComfortably" element={<TooComfortably/>} />
    <Route path="/About" element={<About/>} />
    <Route path="/GrimReynolds" element={<GrimReynolds/>} />
    <Route path="/BookmarksForBrooklynPark" element={<BookmarksForBrooklynPark/>} />
    <Route path="/All52" element={<All52/>} />
    <Route path="/AHole" element={<AHole/>} />
    <Route path="/HDYLSWWYD" element={<HDYLSWWYD/>} />
    <Route path="/WetCloud" element={<WetCloud/>} />
    <Route path="/About" element={<About/>} />
    <Route path="/SuperSonic" element={<SuperSonic/>} />
    <Route path="/ShapeOfYou" element={<ShapeOfYou/>} />
    <Route path="/MajorMinorFair" element={<MajorMinorFair/>} />
    <Route path="/Workshops" element={<Workshops/>} />
    <Route path="/OpenMic" element={<OpenMic/>} />
    <Route path="/Shoelaces" element={<Shoelaces/>} />
    <Route path="/MotionReel" element={<MotionReel/>} />
    <Route path="/Preach" element={<Preach/>} />
    <Route path="/PoetryAndPerformance" element={<PoetryAndPerformance/>} />
    <Route path="/GYMcad" element={<GYMcad/>} />
    <Route path="/WeatherBody" element={<WeatherBody/>} />
    <Route path="/KidsTable" element={<KidsTable/>} />
    <Route path="/NineteenRules" element={<NineteenRules/>} />
    <Route path="/FreedomSchool" element={<FreedomSchool/>} />
</Routes>
      
</div>



<footer>
  <hr/>
  <br/>
        <h7> 
          
                Originally from Iowa, Amar attended the Minneapolis College of Art and Design, graduating with a BFA in Graphic Design.
              Amar began working at the Minneapolis Institute of Art as a teaching artist and studio assistant during their undergrad. 
              
              <br/><br/>As an educator, Amar is passionate about making knowledge accesible: Art History, Grant Writing,	Printmaking Techniques, Public and Interactive Arts, Ideation Techniques, Exhibition Design, and Fundemental Design Practices. The more You know, the stronger We are.

              <br/><br/>
              You can find Amar's work all the way from, from Main Street, Ames, Iowa,
              to the Bauhaus in Weimar, Germany (SoSe 25'). Amar finds themselves floating around to local open mics, stages, 
              and indie films sets in Minneapolis.
              <br/><br/>
          Amar is inspired by southern soul, hip-hop, and Shel Silverstein’s poetry. Culturally expressive and vibrant identities that that don’t ask for forgiveness, or permission. Amar is known to bring a unique spirit to small in-house studios, classrooms, and to 200+ employee museums.
<br/><br/>
        The first time Nina Simone met Martin Luther King, 
        she looked him in the eye and told him: “I am not nonviolent.”  

        <a href="https://www.thetimes.com/sunday-times-rich-list/profile/article/what-happened-miss-simone-a-biography-by-alan-light-96bvwn9v7">
          What Happened, Miss Simone? A Biography by Alan Light.
        </a>
<br/><br/>
  Amar Agba.
<br/><br/>
    <a href="wetcloud@proton.me"> wet.cloud@proton.me<br/></a>
    <a href="https://www.instagram.com/caagbaart/">@caagbaart<br/></a>
    <br/>
    2026. </h7>
<br/><br/>



</footer>

</BrowserRouter>
    
  );
}


export default App;
